import { render, staticRenderFns } from "./WpCustomer.vue?vue&type=template&id=3a6afff0&scoped=true"
import script from "./WpCustomer.vue?vue&type=script&lang=js"
export * from "./WpCustomer.vue?vue&type=script&lang=js"
import style0 from "./WpCustomer.vue?vue&type=style&index=0&id=3a6afff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6afff0",
  null
  
)

export default component.exports